import React from 'react';

const STATS = [
  { number: '500+',   label: 'Devices Connected' },
  { number: '50+',    label: 'Buildings Managed' },
  { number: '99.9%',  label: 'Platform Uptime' },
  { number: '24/7',   label: 'Real-time Monitoring' },
];

const StatsSection = () => (
  <section className="landing-stats">
    <div className="stats-grid">
      {STATS.map(s => (
        <div className="stat-item" key={s.label}>
          <div className="stat-number">{s.number}</div>
          <div className="stat-label">{s.label}</div>
        </div>
      ))}
    </div>
  </section>
);

export default StatsSection;
